<template>
<div class="chapter">
<div class="inner_page">
<p class="toch">Contents</p>
<p class="toc1"><a href="#/fwd#sun520" id="mon520">FOREWORD</a></p>
<p class="toc"><a href="#/chap01#sun500" id="mon500">1</a></p>
<p class="toc1"><a href="#/london#sun518" id="mon518">LONDON 1944</a></p>
<p class="toc"><a href="#/chap02#sun501" id="mon501">2</a></p>
<p class="toc"><span href="#/chap03#sun502" id="mon502" title="Link target outside of Sample">3</span></p>
<p class="toc"><span href="#/chap04#sun503" id="mon503" title="Link target outside of Sample">4</span></p>
<p class="toc"><span href="#/chap05#sun504" id="mon504" title="Link target outside of Sample">5</span></p>
<p class="toc"><span href="#/chap06#sun505" id="mon505" title="Link target outside of Sample">6</span></p>
<p class="toc"><span href="#/chap07#sun506" id="mon506" title="Link target outside of Sample">7</span></p>
<p class="toc"><span href="#/chap08#sun507" id="mon507" title="Link target outside of Sample">8</span></p>
<p class="toc"><span href="#/chap09#sun508" id="mon508" title="Link target outside of Sample">9</span></p>
<p class="toc"><span href="#/chap10#sun509" id="mon509" title="Link target outside of Sample">10</span></p>
<p class="toc"><span href="#/chap11#sun510" id="mon510" title="Link target outside of Sample">11</span></p>
<p class="toc"><span href="#/chap12#sun511" id="mon511" title="Link target outside of Sample">12</span></p>
<p class="toc"><span href="#/chap13#sun512" id="mon512" title="Link target outside of Sample">13</span></p>
<p class="toc"><span href="#/chap14#sun513" id="mon513" title="Link target outside of Sample">14</span></p>
<p class="toc"><span href="#/chap15#sun514" id="mon514" title="Link target outside of Sample">15</span></p>
<p class="toc"><span href="#/chap16#sun515" id="mon515" title="Link target outside of Sample">16</span></p>
<p class="toc1"><span href="#/jersy#sun517" id="mon517" title="Link target outside of Sample">JERSEY 1985</span></p>
<p class="toc"><span href="#/chap17#sun516" id="mon516" title="Link target outside of Sample">17</span></p>
<p class="toc1"><span href="#/bio#bio01" id="toc_bio" title="Link target outside of Sample">A BIOGRAPHY OF JACK HIGGINS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4b9677ca